import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, option_type, array_type, string_type, bool_type, class_type, union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Settings_DokumentenabrufSettings_$reflection, Settings_Settings_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { ServerError_$reflection } from "../../../../Bfs.Web.Shared.FSharp/Errors.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";

export class Page extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Settings"];
    }
}

export function Page_$reflection() {
    return union_type("Settings.Types.Page", [], Page, () => [[]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadSettings", "SettingsLoaded", "TryChangeDokumentenabruf", "ChangeDokumentenabrufTried", "ChangeDokumentenabrufSetting", "DokumentenabrufSettingChanged", "PrintVereinbarung", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.Types.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Settings_Settings_$reflection(), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", Settings_Settings_$reflection()]], [["ErrorValue", ServerError_$reflection()]]])]], [["Item1", class_type("System.Guid")], ["Item2", bool_type]], [["Item1", class_type("System.Guid")], ["Item2", bool_type], ["Item3", union_type("Microsoft.FSharp.Core.FSharpResult`2", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]]), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["ErrorValue", ServerError_$reflection()]]])]], [["Item1", class_type("System.Guid")], ["Item2", bool_type]], [["Item1", class_type("System.Guid")], ["Item2", bool_type], ["Item3", union_type("Microsoft.FSharp.Core.FSharpResult`2", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]]), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["ErrorValue", ServerError_$reflection()]]])]], [["Item", string_type]], [["Item", GlobalMsg_$reflection()]]]);
}

export class Model extends Record {
    constructor(Filialen) {
        super();
        this.Filialen = Filialen;
    }
}

export function Model_$reflection() {
    return record_type("Settings.Types.Model", [], Model, () => [["Filialen", option_type(array_type(Settings_DokumentenabrufSettings_$reflection()))]]);
}

export function Model_Init() {
    return new Model(undefined);
}

//# sourceMappingURL=Types.fs.js.map
